import actionTypes from '../constants/action-types';
import globals from '../../globals';
import DEFAULT_OPTIONS from '../constants/default-options';

const shiftElement = (elementId, refElementId, position = 'afterend', options = DEFAULT_OPTIONS) =>
  globals.helpers.globalActionExtender({
    type: actionTypes.SHIFT_ELEMENT,
    payload: {
      elementId,
      refElementId,
      position,
      options,
    },
  });

export default shiftElement;
